module.exports = __webpack_public_path__ + "static/fonts/iconfont.8589d3b.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/iconfont.eot?t=1589351592175
// module id = s2wz
// module chunks = 1